// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/style.css
// module id = 2680
// module chunks = 29